<template>
    <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 shadow" role="alert">
        <p class="font-semibold mb-2">
            <slot name="text"/>
        </p>
        <p class="text-sm">
            <slot name="description"/>
        </p>
    </div>
</template>

<script>

    export default {
        props: {
            text: {
                type: String,
            },
            description: {
                type: String,
            },
        },
        methods: {}
    }
</script>
